<span #userMenuTrigger>
  <lib-icon-button
    [icon]="'user'"
    [ariaLabel]="'userMenu.ariaLabel' | translate"
  ></lib-icon-button>
</span>

<lib-dropdown
  [triggerElement]="userMenuTrigger"
  [items]="menuItems"
  (selectDropdownOption)="onProfileOption($event)"
  position="below"
>
  <div class="user-info">
    <div>{{ userFullName() }}</div>
    <div class="label">{{ userEmail() }}</div>
    @if (userRole()) {
      <div style="margin-top: 8px">
        <lib-badge
          [label]="userRole()"
          [colorScheme]="roleBadgeColor()"
        />
      </div>
    }
  </div>

  <div class="separator"></div>
</lib-dropdown>
